export const genderOptions = [
    'Male',
    'Female',
    'Non-binary',
    'Agender',
    'Genderfluid',
    'Femboy',
    'Filipino',
    'Stickman',
    'Fruit tart',
    'Fucked up Rubik cube',
    'Prefer not to say']